// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { NotFoundPage } from '../pages/NotFoundPage/NotFoundPage';

export const Route = createFileRoute('/404')({
  component: NotFoundPage,
});
